export default {
  title: "Служба поддержки",
  rules: {
    note: "Перед отправкой запроса, пожалуйста, ознакомьтесь с правилами:",
    rule_1: "1. Предварительно изучите раздел {faq} (FAQ) — возможно, ответ уже там.",
    rule_2: "2. В случае проблем с оплатой обязательно приложите к сообщению детали транзакции (дата, сумма, способ оплаты, скриншоты).",
    rule_3: "3. При проблемах со скачиванием файлов обязательно укажите ссылки на эти файлы.",
    rule_4: "4. По вопросам авторских прав или любых других файлов, нарушающих правила, обращайтесь на адрес: {email}",
    rule_5: "5. По вопросам сотрудничества, партнёрских программ, рекламы и других бизнес-предложений пишите на адрес: {email}",
    rule_6: "6. Ответ может занимать от 12 часов до 2 рабочих дней, в зависимости от сложности запроса и загруженности службы поддержки.",
    rules: "правила",
    faq: "часто задаваемых вопросов"
  },
  messages: {
    note: "*Отоборажаются последние {count} сообщений",
    you: "Вы",
    support: "Служба поддержки",
    autoanswer_subject_is_over: "Беседа закрыта, так как Ваш вопрос был решён.\nБлагодарим за обращение в службу поддержки."
  },
  inputs: {
    message: {
      placeholder: "Напишите ваш вопрос"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "Прикрепить файл",
      attached_files: "Прикрепленные файлы:"
    }
  },
  errors: {
    generic: "Ошибка",
    invalid_file_type: "Неподдерживаемый формат файла.",
    max_file_size_limit: "Файл слишком большой. Выберите файл меньшего размера.",
    filename_too_long: "Имя файла слишком длинное",
    filename_invalid_chars: "Имя файла содержит недопустимые символы"
  },
  btn: {
    send: "Отправить"
  }
};
